import { string, object, boolean, mixed } from 'yup';
import { translate } from '../Services/translation';
import constants from '../constants';

const registerLicenseCodeSchema = object().shape({
    licenseCode: string().required(translate('js.registerlicensecode.validation.code.notempty')),
});

export {
    registerLicenseCodeSchema
};